import "./App.css";

const Footer = () => {
  return (
    <footer className="footer footer-center p-4 py-4 border-t-4 bg-white text-base-content sm:text-sm">
      <div>
        <p>Copyright © 2023 - All right reserved by aramid Ltd</p>
      </div>
    </footer>
  );
};


export default Footer;